import { render, staticRenderFns } from "./noPass.vue?vue&type=template&id=34e50d22&scoped=true"
import script from "./noPass.vue?vue&type=script&lang=js"
export * from "./noPass.vue?vue&type=script&lang=js"
import style0 from "./noPass.vue?vue&type=style&index=0&id=34e50d22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e50d22",
  null
  
)

export default component.exports